define(function (require, exports) {
    'use strict';

    /**
     * Directive for payments hardtoken
     */
    exports.metHardtoken = function () {

        var template = [
            '<div class="hard-token">',
            '    <form name="hardtokenForm">',
            '        <label>Please enter your 8 digit hard token code</label>',
            '        <input',
            '            type="password"',
            '            parent-class="ct-hardtoken"',
            '            class="input-hardtoken"',
            '            ng-model="ngModel"',
            '            ng-pattern="/^[a-zA-Z0-9]*$/"',
            '            maxlength="8"',
            '            error-messages="hardTokenErrorMessages"',
            '            met-input required />',
            '    </form>',
            '</div>'
        ].join('');

        var link = function (scope) {
            scope.hardTokenErrorMessages = {
                required: 'Please enter hardtoken'
            };
        };

        return {
            restrict: 'EA',
            scope: {
                ngModel: '='
            },
            link: link,
            template: template
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metHardtoken/metHardtoken.js